module.exports = __webpack_public_path__ + "img/ma.7071507a.png";